import { computed } from 'vue';
import { useStoreGetters } from 'dashboard/composables/store';
import {
  getCurrentAccount,
  getUserPermissions,
} from 'dashboard/helper/permissionsHelper';

/**
 * Composable to determine if the current user is an administrator.
 * @returns {Boolean} - True if the current user is an administrator, false otherwise.
 */
export function useAdmin() {
  const getters = useStoreGetters();

  const currentUserRole = computed(() => getters.getCurrentRole.value);
  const isAdmin = computed(() => currentUserRole.value === 'administrator');
  // Fork JavaMifi: admin organisasi (role agent + permission organization_admin).
  const isOrganizationAdmin = computed(() =>
    getUserPermissions(
      getters.getCurrentUser.value,
      getters.getCurrentAccountId.value
    ).includes('organization_admin')
  );

  const currentOrganizationId = computed(
    () =>
      getCurrentAccount(
        getters.getCurrentUser.value,
        getters.getCurrentAccountId.value
      )?.organization_id ?? null
  );

  return {
    isAdmin,
    isOrganizationAdmin,
    currentOrganizationId,
  };
}
